import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserInvitedProcedures } from "../../api/app";
import { ProcedureList } from "../../components/Procedure";
import { TenderProcedure } from "../../types/model/procedure/TenderProcedure";

type ProcedureFilter = "total" | "active" | "ending" | null;
type ProcedureOrderBy = "ending_soon" | "latest_invited";

const TenderProcedures = () => {
  const navigate = useNavigate();

  const [procedures, setProcedures] = useState<TenderProcedure[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activeFilter, setActiveFilter] = useState<ProcedureFilter>("active");

  const fetchData = async (
    isOpen = true,
    orderBy?: ProcedureOrderBy,
  ) => {
    setLoading(true);
    try {
      const proceduresList = await getUserInvitedProcedures({ isOpen, orderBy });
      setProcedures(proceduresList);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filter: ProcedureFilter) => {
    setActiveFilter(filter);

    switch (filter) {
      case "total":
        fetchData(false);
        break;

      case "active":
        fetchData(true, "latest_invited");
        break;

      case "ending":
        fetchData(true, "ending_soon");
        break;

      default:
        fetchData(false);
        break;
    }
  };

  useEffect(() => {
    handleFilterChange(activeFilter);
  }, []);

  const handleRequestRefresh = () => {
    handleFilterChange(activeFilter);
  };

  const handleProcedureSelect = (procedure: TenderProcedure) => {
    navigate(`/accounts/${procedure.accountId}/projects/${procedure.projectId}/activities/${procedure.activityId}/procedures/${procedure.id}`);
  };

  return (
    <ProcedureList
      procedures={procedures}
      loading={loading}
      onRefresh={handleRequestRefresh}
      onProcedureSelected={(p) => handleProcedureSelect(p as TenderProcedure)}
      readOnly={true}
      activeFilter={activeFilter}
      onActiveFilterChange={handleFilterChange}
    />
  );
};

export default TenderProcedures;
